import API from "@/api/api-main";

export async function getDataGoldPrice() {
    try {
        const { data } = await API.get(`GoldPriceList/getall?Filter=(type=V,status=A)`);
        return data?.items?.data[0] || [];
    } catch (error) {
        return [];
    }
}

export async function getDataGoldPriceBAC() {
    try {
        const { data } = await API.get(`GoldPriceList/getall?Filter=(type=B,status=A)`);
        return data?.items?.data[0] || [];
    } catch (error) {
        return [];
    }
}
